import { getCartItemLevel } from '@strix/checkout/helpers/cartItemLevel'
import { getCartItemLevel as getCartItemLevelRo } from '@strix/checkout/helpers/cartItemLevelRo'
import { beneficiariesAvailable } from '@strix/checkout/helpers/beneficiaries'
import { isPhysicalProduct } from '@strix/checkout/helpers/productsType'

export const getters = {
  getSecondsDiff (state) {
    // @todo data/czas przychodzi bez oznaczenia GMT
    const endTS = new Date(`${state.reservationTimeout}+0000`).getTime()
    const diff = Math.floor((endTS - state.now) / 1000)

    return diff > 0 ? diff : 0
  },
  getTimeLeft (_state, getters) {
    const minutes = Math.floor(getters.getSecondsDiff / 60)
    const seconds = getters.getSecondsDiff - minutes * 60

    return {
      minutes,
      seconds,
    }
  },
  getFilteredItems (state) {
    const { items } = state

    const itemsGrouped = items.reduce((acc, value) => {
      const isGrouped = value.additionalOptions.find(item => item.label === 'grouping_number')

      if (isGrouped) {
        if (Object.prototype.hasOwnProperty.call(acc, isGrouped.value)) {
          acc[isGrouped.value].push(value)
        } else {
          acc[isGrouped.value] = [value]
        }
      } else {
        acc[value.uid] = value
      }

      return acc
    }, {})

    const splitPerVendorAndPhysical = Object.values(itemsGrouped).reduce((acc, item) => {
      const { product: { _typename }, vendor: { vendorId } } = Array.isArray(item) ? item[0] : item

      acc[vendorId] = acc[vendorId] || {
        physical: [],
        rest: [],
      }

      const type = [
        'PhysicalProduct',
        'LensesProduct',
      ].includes(_typename)
        ? 'physical'
        : 'rest'

      acc[vendorId][type].push(item)

      return acc
    }, {})

    const withPhysicalFirst = Object.values(splitPerVendorAndPhysical).sort((a, b) => {
      const aPhysical = a.physical.length ? -1 : 1
      const bPhysical = b.physical.length ? -1 : 1

      return aPhysical - bPhysical
    })

    return withPhysicalFirst.flatMap(({ physical, rest }) => ([...physical, ...rest]))
  },
  getMaterialFeeItems ({ items }) {
    return items.filter(({ _typename }) => _typename === 'MaterialFeeCartItem')
  },
  getMaterialFeeProducts ({ items }) {
    return items.filter(item => item.hasMaterialFee)
  },
  getItemsQuantity (state, getters) {
    const mergeProducts = getters.getFilteredItems

    return Object.values(mergeProducts).reduce((acc, item) => {
      acc = Array.isArray(item) ? acc += 1 : acc += item.quantity
      return acc
    }, 0)
  },
  getItems (state) {
    return state.items
  },
  getAvailablePaymentMethods (state) {
    return state
  },
  getBeneficiaryItems (state) {
    return state.items.filter(beneficiariesAvailable)
  },
  getPrices (state) {
    return state.prices
  },
  getMediclubPrices (state) {
    return state.mediclubPrices
  },
  getNoMediclubPrices (state) {
    return state.noMediclubPrices
  },
  getAppliedCoupons (state) {
    return state.appliedCoupons
  },
  getCurrentStep (state) {
    return state.currentStep
  },
  getPaymentMethods (state) {
    return state.paymentMethods
  },
  getLevelForCartItems ({ items }) {
    return items.reduce((lvl, item) => {
      const productLvl = getCartItemLevel(item)

      return lvl > productLvl ? lvl : productLvl
    }, 0)
  },
  getLevelForCartItemsRo ({ items }) {
    return items.reduce((lvl, item) => {
      const productLvl = getCartItemLevelRo(item)

      return lvl > productLvl ? lvl : productLvl
    }, 0)
  },
  isRegisteredOnCheckout (state) {
    return state.isRegisteredOnCheckout
  },
  hasOnlyShippingProducts (state) {
    return state.items.every((item) => {
      return isPhysicalProduct(item._typename)
    })
  },
  hasOnlyOnePhysicalProducts (state) {
    return state.items.some((item) => {
      return isPhysicalProduct(item._typename)
    })
  },
  hasOnlyTrainingProductsFromRehasport (state) {
    return state.items.every(({ _typename, vendor: { name } }) => {
      return _typename === 'TrainingCartItem' && name === 'Rehasport'
    })
  },
  hasOnlyProductsFromDiagnostyka (state) {
    return state.items.every(({ vendor: { name } }) => {
      return name === 'Diagnostyka'
    })
  },
}
